import { useState } from "react";
import { MessageSquareWarning, Check } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Corrección de un desvío por el mando: se guarda con los cortes del evento para convertirla en caso de referencia del motor
export const DetourFeedbackButton = ({ eventId, d, edited, sent, onSent, compact }) => {
  const flows = [{ v: "", label: d.from ? `Desde ${d.from}` : "Desvío principal", streets: d.streets }, ...(d.branches || []).map((b) => ({ v: b.from, label: `Desde ${b.from}`, streets: b.streets }))];
  const [open, setOpen] = useState(false);
  const [flow, setFlow] = useState("");
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      await api.post(`/events/${eventId}/detour-feedback`, { element_id: d.element_id, branch: flow || null, comment });
      toast.success("Corrección enviada: se revisará y pasará a formar parte del motor de desvíos");
      setOpen(false); setComment(""); onSent?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button size="sm" variant="outline" className={compact ? "h-8" : "h-7 text-[0.6875rem]"} onClick={() => setOpen(true)} data-testid={`detour-feedback-button-${d.element_id}`}>
        {sent ? <Check className="w-3.5 h-3.5 mr-1 text-emerald-600" /> : <MessageSquareWarning className="w-3.5 h-3.5 mr-1" />}
        {sent ? "Corrección enviada" : "Corregir desvío"}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid="detour-feedback-dialog">
          <DialogHeader><DialogTitle className="font-display">Corregir desvío · {d.element_name}</DialogTitle></DialogHeader>
          <div className="space-y-4 text-sm">
            {flows.length > 1 && (
              <div>
                <div className="text-xs text-slate-600 mb-1.5">¿Qué tráfico está mal desviado?</div>
                <div className="space-y-1.5">
                  {flows.map((f) => (
                    <label key={f.v || "main"} className={`flex items-start gap-2 rounded-lg border px-3 py-2 cursor-pointer ${flow === f.v ? "border-sky-400 bg-sky-50" : "border-slate-200"}`}>
                      <input type="radio" name="flow" checked={flow === f.v} onChange={() => setFlow(f.v)} className="mt-1 accent-sky-600" />
                      <span><b>{f.label}</b><span className="block text-xs text-slate-500">{f.streets?.join(" → ") || "Vía sin nombre"}</span></span>
                    </label>
                  ))}
                </div>
              </div>
            )}
            <div>
              <div className="text-xs text-slate-600 mb-1.5">¿Qué debería hacer el tráfico? (calles por las que tiene que ir, giros prohibidos…)</div>
              <textarea value={comment} onChange={(e) => setComment(e.target.value)} rows={4} maxLength={2000} data-testid="detour-feedback-comment"
                className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:border-sky-500" placeholder="Ej.: el tráfico de Rúa da Ponte debe girar a la derecha por Doutor Touriño Gamallo" />
            </div>
            <div className="text-xs text-slate-500 bg-slate-50 border border-slate-200 rounded-lg px-3 py-2">
              {edited ? "Se adjunta el trazado que ha dibujado a mano para este corte." : "Si quiere, antes de enviar dibuje el itinerario correcto con «Editar trazado» en el panel del desvío: se adjunta solo."}
            </div>
          </div>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setOpen(false)}>Cancelar</Button>
            <Button onClick={send} disabled={busy || comment.trim().length < 3} data-testid="detour-feedback-send">Enviar corrección</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
